export const initMixpanel = (): void => {
  const token = process.env.REACT_APP_MIXPANEL_TOKEN;
  if (!token) {
    console.log("Mixpanel token not found, skipping initialization");
    return;
  }
  
  (function (e: Document, c: any) {
    if (!c.__SV) {
      window.mixpanel = c;
      c._i = [];

      c.init = function (q: string, r: any, f?: string) {
        function t(d: any, a: string) {
          const g = a.split(".");
          if (g.length === 2) {
            if (d[g[0]] === undefined) d[g[0]] = [];
            d = d[g[0]];
            a = g[1];
          }

          d[a] = function (...args: any[]) {
            
            d.push([a].concat(args));
          };
        }

        let b = c;
        if (typeof f !== "undefined") b = c[f] = [];
        else f = "mixpanel";

        const methods =
          "disable track track_pageview track_links track_forms register register_once alias identify name_tag set_config reset people.set".split(
            " "
          );

        for (let i = 0; i < methods.length; i++) {
          t(b, methods[i]);
        }

        c._i.push([q, r, f]);
      };

      c.__SV = 1.2;

      const k = e.createElement("script");
      k.type = "text/javascript";
      k.async = true;
      k.src = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";

      const s = e.getElementsByTagName("script")[0];
      s.parentNode?.insertBefore(k, s);
    }
  })(document, (window as any).mixpanel || []);

  window.mixpanel.init(token as any, {
    autocapture: true,
    record_sessions_percent: 100,
  });
};